
import { FieldsByPropertyCategory, Field  } from '../types/PropertyCategory';

export const getFieldsByPropertyCategory= (propertyCategory: string): Field[] => {
  return FieldsByPropertyCategory[propertyCategory] || [];
};
